import io from 'socket.io-client';
window.io = io;

import Echo from "laravel-echo"
window.Echo = new Echo({
  broadcaster: 'socket.io',
  host: SOCKETURL,
  namespace: false,
  transports: ['websocket', 'polling', 'flashsocket'], // Fix CORS error!
  auth:        {
    headers: {
        Authorization: 'Bearer ' + SOCKETKEY
    },
  },
});




// WEBPACK FOOTER //
// ./src/assets/services/socket.js